"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPE_PADDING_MOBILE = exports.TYPE_PADDING = exports.TYPE_MARGIN = exports.TYPE_LOCKS = exports.TYPE_BOX_SHADOW = exports.TYPE_BORDER_Y = exports.TYPE_BORDER_X = exports.TYPE_BORDER_WIDTH = exports.TYPE_BORDER_STYLE = exports.TYPE_BORDER_COLOR = exports.TYPE_BACKGROUND_VIDEO = exports.TYPE_BACKGROUND_SIZE = exports.TYPE_BACKGROUND_REPEAT = exports.TYPE_BACKGROUND_POSITION = exports.TYPE_BACKGROUND_MODE = exports.TYPE_BACKGROUND_LOADING_METHOD = exports.TYPE_BACKGROUND_IMAGE = exports.TYPE_BACKGROUND_COLOR_OPACITY = exports.TYPE_BACKGROUND_COLOR = exports.TYPE_BACKGROUND_ALT_TEXT = exports.TYPE_ANIMATION_STYLE = exports.TYPE_ANIMATION_HOVER = exports.TYPE_ANIMATION_DURATION = exports.TYPE_ANIMATION_DELAY = exports.TYPE_ANCHOR_ID = exports.STATE_KEY_POSITION = exports.STATE_KEY_EFFECTS = exports.STATE_KEY_BORDER = exports.STATE_KEY_BACKGROUND = exports.STATE_KEY_ANCHOR = exports.DIRECTION_VERT = exports.DIRECTION_HORZ = exports.BACKGROUND_MODE_VIDEO_FLAG = exports.BACKGROUND_MODE_IMAGE_FLAG = exports.BACKGROUND_MODE_COLOUR_FLAG = void 0;
var STATE_KEY_POSITION = '__peracto_block_position';
exports.STATE_KEY_POSITION = STATE_KEY_POSITION;
var STATE_KEY_BACKGROUND = '__peracto_block_background';
exports.STATE_KEY_BACKGROUND = STATE_KEY_BACKGROUND;
var STATE_KEY_BORDER = '__peracto_block_border';
exports.STATE_KEY_BORDER = STATE_KEY_BORDER;
var STATE_KEY_EFFECTS = '__peracto_block_effects';
exports.STATE_KEY_EFFECTS = STATE_KEY_EFFECTS;
var STATE_KEY_ANCHOR = '__peracto_anchor';
exports.STATE_KEY_ANCHOR = STATE_KEY_ANCHOR;
var TYPE_PADDING = 'padding';
exports.TYPE_PADDING = TYPE_PADDING;
var TYPE_PADDING_MOBILE = 'paddingMobile';
exports.TYPE_PADDING_MOBILE = TYPE_PADDING_MOBILE;
var TYPE_MARGIN = 'margin';
exports.TYPE_MARGIN = TYPE_MARGIN;
var TYPE_LOCKS = 'locks';
exports.TYPE_LOCKS = TYPE_LOCKS;
var TYPE_BACKGROUND_COLOR = 'backgroundColor';
exports.TYPE_BACKGROUND_COLOR = TYPE_BACKGROUND_COLOR;
var TYPE_BACKGROUND_COLOR_OPACITY = 'backgroundColorOpacity';
exports.TYPE_BACKGROUND_COLOR_OPACITY = TYPE_BACKGROUND_COLOR_OPACITY;
var TYPE_BACKGROUND_IMAGE = 'backgroundImage';
exports.TYPE_BACKGROUND_IMAGE = TYPE_BACKGROUND_IMAGE;
var TYPE_BACKGROUND_VIDEO = 'backgroundVideo';
exports.TYPE_BACKGROUND_VIDEO = TYPE_BACKGROUND_VIDEO;
var TYPE_BACKGROUND_POSITION = 'backgroundPosition';
exports.TYPE_BACKGROUND_POSITION = TYPE_BACKGROUND_POSITION;
var TYPE_BACKGROUND_SIZE = 'backgroundSize';
exports.TYPE_BACKGROUND_SIZE = TYPE_BACKGROUND_SIZE;
var TYPE_BACKGROUND_REPEAT = 'backgroundRepeat';
exports.TYPE_BACKGROUND_REPEAT = TYPE_BACKGROUND_REPEAT;
var TYPE_BACKGROUND_MODE = 'backgroundMode';
exports.TYPE_BACKGROUND_MODE = TYPE_BACKGROUND_MODE;
var TYPE_BACKGROUND_LOADING_METHOD = 'backgroundLoadingMethod';
exports.TYPE_BACKGROUND_LOADING_METHOD = TYPE_BACKGROUND_LOADING_METHOD;
var TYPE_BACKGROUND_ALT_TEXT = 'backgroundAltText';
exports.TYPE_BACKGROUND_ALT_TEXT = TYPE_BACKGROUND_ALT_TEXT;
var TYPE_BORDER_X = 'borderX';
exports.TYPE_BORDER_X = TYPE_BORDER_X;
var TYPE_BORDER_Y = 'borderY';
exports.TYPE_BORDER_Y = TYPE_BORDER_Y;
var TYPE_BORDER_WIDTH = 'borderWidth';
exports.TYPE_BORDER_WIDTH = TYPE_BORDER_WIDTH;
var TYPE_BORDER_COLOR = 'borderColor';
exports.TYPE_BORDER_COLOR = TYPE_BORDER_COLOR;
var TYPE_BORDER_STYLE = 'borderStyle';
exports.TYPE_BORDER_STYLE = TYPE_BORDER_STYLE;
var TYPE_ANIMATION_STYLE = 'animationStyle';
exports.TYPE_ANIMATION_STYLE = TYPE_ANIMATION_STYLE;
var TYPE_ANIMATION_DELAY = 'animationDelay';
exports.TYPE_ANIMATION_DELAY = TYPE_ANIMATION_DELAY;
var TYPE_ANIMATION_DURATION = 'animationDuration';
exports.TYPE_ANIMATION_DURATION = TYPE_ANIMATION_DURATION;
var TYPE_ANIMATION_HOVER = 'animationHover';
exports.TYPE_ANIMATION_HOVER = TYPE_ANIMATION_HOVER;
var TYPE_BOX_SHADOW = 'boxShadow';
exports.TYPE_BOX_SHADOW = TYPE_BOX_SHADOW;
var TYPE_ANCHOR_ID = 'anchorId';
exports.TYPE_ANCHOR_ID = TYPE_ANCHOR_ID;
var DIRECTION_VERT = 'vertical';
exports.DIRECTION_VERT = DIRECTION_VERT;
var DIRECTION_HORZ = 'horizontal';
exports.DIRECTION_HORZ = DIRECTION_HORZ;
var BACKGROUND_MODE_COLOUR_FLAG = 1;
exports.BACKGROUND_MODE_COLOUR_FLAG = BACKGROUND_MODE_COLOUR_FLAG;
var BACKGROUND_MODE_IMAGE_FLAG = 2;
exports.BACKGROUND_MODE_IMAGE_FLAG = BACKGROUND_MODE_IMAGE_FLAG;
var BACKGROUND_MODE_VIDEO_FLAG = 3;
exports.BACKGROUND_MODE_VIDEO_FLAG = BACKGROUND_MODE_VIDEO_FLAG;